export enum PRINT_CLASSES {
    LAYOUT_PRINT = 'layout-print',
    LAYOUT_FULL_HEIGHT = 'layout-full-height',
    HIDE_HEADER = 'print-hide-header',
    HIDE_SIDEBAR = 'print-hide-sidebar',
    HIDE_SYNC_ERROR_MESSAGE = 'print-hide-sync-error-message'
};
